<div class="wrapper">
  <div class="main">
    <ng-container *appLoading="questions$ | async as questions">
      @for (question of questions; track question) {
      <question [parameter]="question" (parameterChanged)="updateParameter($event)"></question>
      <app-separator></app-separator>
      }
    </ng-container>
  </div>
  <div class="spacer"></div>
  <div class="sidebar">
    @if (recommendation$ | async; as recommendation) {
    <recommendation-sidebar class="sidebar-content" [recommendation]="recommendation"></recommendation-sidebar>
    }
  </div>
</div>
<ng-template #footerTemplate>
  <app-questionnaire-footer></app-questionnaire-footer>
</ng-template>
